const StatMainView = () => import('@/views/superadmin/stat/StatMainView')
const StatSchoolsView = () => import('@/views/superadmin/stat/StatSchoolsView')
const StatMunicipalityView = () => import('@/views/superadmin/stat/StatMunicipalityView')

export default {
  path: 'stat',
  redirect: { name: 'StatSchoolsSuperAdmin' },
  name: 'StatMainSuperAdmin',
  component: StatMainView,
  meta: { label: 'Статистика' },
  children: [
    {
      path: 'schools',
      name: 'StatSchoolsSuperAdmin',
      component: StatSchoolsView,
      meta: { label: 'Школы' },
    },
    {
      path: 'municipality',
      name: 'StatMunicipalitySuperAdmin',
      component: StatMunicipalityView,
      meta: { label: 'Муниципалитеты' },
    },
  ]
}